module.exports = __webpack_public_path__ + "img/logo.387c0c74.png";